/**
 * Card Swatches
 * @desc handles dyanmic image update when card swatches are enabled
 * @returns {Function} init
 */
if (!customElements.get('card-swatches')) {
  customElements.define(
    'card-swatches',
    class CardSwatches extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          dom: {
            card: '[data-card]',
            cardImage: '[data-card-image]',
            swatchLink: '[data-swatch-link]',
            swatchList: '[data-swatch-list]',
          },
          cls: {
            active: 'active',
          },
        };
        window.dataCache = window.dataCache || {};
        this.$swatchLinks = this.querySelectorAll(this.selectors.dom.swatchLink);
        if (this.$swatchLinks.length) {
          this.addEvents();
        }
      }

      /**
       * Add Events
       * @desc Adds all relevent event listeners
       */
      addEvents() {
        this.$swatchLinks.forEach(($el) => {
          $el.addEventListener('click', (e) => this.handleSwatchClick(e));
        });
      }

      /**
       * Handle Card Update
       * @param {Object} e click event
       */
      handleSwatchClick(e) {
        e.preventDefault();
        this.$linkTarget = e.target.closest(this.selectors.dom.swatchLink);
        this.$swatchList = e.target.closest(this.selectors.dom.swatchList);
        this.$card = e.target.closest(this.selectors.dom.card);
        this.$cardImage = this.$card.querySelector(this.selectors.dom.cardImage);
        this.$variantId = this.$linkTarget.getAttribute('data-variant-id');
        this.$formInput = this.$card.querySelector('product-form input[name="id"]');
        this.updateCardImage(this.$linkTarget, this.$cardImage);
        this.updateSwatchState(this.$linkTarget, this.$swatchList);
        this.updateFormId(this.$variantId, this.$formInput);
      }

      /**
       * Get Product Data
       * @param {String} productHandle
       * @returns {Object} productData
       */
      async getProductData(productHandle) {
        let productData = null;
        if (!window.dataCache[productHandle]) {
          const data = await fetch(`${window.Shopify.routes.root}products/${productHandle}.js`).then((response) =>
            response.json()
          );
          window.dataCache[productHandle] = data;
        }
        productData = window.dataCache[productHandle];

        return productData;
      }

      /**
       * Update Card Image
       * @param {Element} $link
       * @param {Element} $image
       */
      async updateCardImage($link, $image) {
        const { variantId, productHandle } = $link.dataset;
        const productData = await this.getProductData(productHandle);
        const currVariant = productData.variants.find((variant) => variant.id === Number(variantId));
        $image.srcset = currVariant?.featured_image?.src || productData.featured_image;
        $image.src = currVariant?.featured_image?.src || productData.featured_image;
        $image.alt = currVariant?.featured_image?.alt || currVariant.name;
      }

      /**
       * Update Swatch State
       * @param {Element} $link
       * @param {Element} $swatchList
       */
      updateSwatchState($link, $swatchList) {
        if ($link.classList.contains('active')) return;
        const $prevActive = $swatchList.querySelector(`${this.selectors.dom.swatchLink}.${this.selectors.cls.active}`);

        if ($prevActive) {
          $prevActive.classList.remove('active');
        }
        $link.classList.add('active');
      }

      /**
       * Update Form Id
       * @param {string} $variantId - The variant ID to set
       * @param {Element} $formInput - The form input element to update
       */
      updateFormId($variantId, $formInput) {
        if ($formInput && typeof $variantId === 'string') {
          $formInput.value = $variantId; // Update the input's value
        } else {
          console.error('Invalid parameters: Ensure $variantId is a string and $formInput is a valid element.');
        }
      }
    }
  );
}
